// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PrepareData,
} from "@insite/client-framework/Store/Components/ProductRecommendations/Handlers/PrepareBrand";
import { generateGeneralPrepare } from "@insite/client-framework/Store/Components/ProductRecommendations/ProductRecommendationsSelector";

export const XngPrepareData: typeof PrepareData = props => {
    const {
        getState,
        parameter: { brandFacets },
    } = props;

    // XNG-Changes: FLIP-1157: adding check for undefined or empty array
    props.recommendation = {
        type: "brand",
        brand: brandFacets.filter(o => o.selected)?.[0]?.name || "",
        ...generateGeneralPrepare(getState()),
    };
};

replaceInChain(chain, PrepareData, XngPrepareData);
